export const GET_CONTACTO = 'GET_CONTACTO'
export const GET_CONTACTO_SUCCESS = 'GET_CONTACTO_SUCCESS'
export const GET_CONTACTO_ERROR = 'GET_CONTACTO_ERROR'

export interface Contacto {
  nombreEjecutivoCuentas: string
  telefono: string
  alias: string | null
  email: string
}
export interface ContactoState {
  contacto: Contacto[] | null
  loading: boolean
  error: boolean
}
export const initialState: ContactoState = {
  contacto: null,
  loading: true,
  error: false,
}
export interface GetContacto {
  type: typeof GET_CONTACTO
  payload: null
}
export interface GetContactoSuccess {
  type: typeof GET_CONTACTO_SUCCESS
  payload: Contacto[]
}
export interface GetContactoError {
  type: typeof GET_CONTACTO_ERROR
  payload: boolean
}

export type ContactoActions = GetContacto | GetContactoSuccess | GetContactoError
